import FacebookLoginButton from "../Facebook";
import GoogleLoginButton from "../Google";
import Label from "../Label";
import styles from "./login.module.scss";

export default function LoginPage() {
  return (
    <div className={styles.loginPageContainer}>
      <div className={styles.socialLoginBlock}>
        <Label text="Welcome to Clubbable" />
        <p className={styles.loginDescription}>
          Continue with Facebook or Google
        </p>
        <FacebookLoginButton />
        <GoogleLoginButton />
        <h3 className={styles.appDownloadUrl}>Download the Clubbable app</h3>
      </div>
    </div>
  );
}
